// @ts-check
import axios from 'axios'

/** @typedef {import('./schema').components['schemas']} Schemas */
/** @typedef {Schemas['JobStatusResponse']} JobStatusResponse */

/**
 * GET /api/jobs/{jobId}/status/ -- check background job progress.
 * @param {string} jobId
 * @returns {Promise<JobStatusResponse>}
 */
export async function getJobStatus(jobId) {
  const { data } = await axios.get(`/api/jobs/${jobId}/status/`)
  return data
}
